const BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};
const getMediaQuery = (mediaQuery) => {
  return window.matchMedia(mediaQuery);
};
const getIsUnderMediaQuery = (name) => {
  return getMediaQuery(`(max-width: ${BREAKPOINTS[name]}px)`);
};
const isUnder = (name) => {
  return getIsUnderMediaQuery(name).matches;
};
const getIsOverMediaQuery = (name) => {
  return getMediaQuery(`(min-width: ${BREAKPOINTS[name]}px)`);
};
const isOver = (name) => {
  return getIsOverMediaQuery(name).matches;
};

export default {
  BREAKPOINTS,
  getMediaQuery,
  getIsUnderMediaQuery,
  isUnder,
  getIsOverMediaQuery,
  isOver,
};
